import {
  faCartPlus,
  faHistory,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import OffSticker from "src/assets/images/website-images/off-sticker.png";
import Danger from "src/assets/images/website-images/danger.png";
import HeartUnFav from "src/assets/images/heart-un-favorite.png";
import HeartFav from "src/assets/images/heart-favorite.png";
import CartPlus from "src/assets/images/website-images/addcart-image-new.png";
import HistoryIcon from "src/assets/images/website-images/history-icon.png";
import PharmaDummyImage from "src/assets/images/website-images/dummy-pharmaproduct-image.png";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import { Link, useNavigate } from "react-router-dom";
import { ImageBaseUrl } from "src/lib/constans";
import { Skeleton } from "@mui/material";
import httpRequest from "src/helpers/httpRequest";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@store/store";
import { tooglePleaseLogin } from "src/Store/reducer";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import PriceView from "src/Components/GlobalComponents/PriceView";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import OutOfStackTag from "src/Components/GlobalComponents/Widget/OutOfStackTag";

interface IProps {
  product?: any;
  className?: string;
  cardClassName?: string;
  id?: string;
  skeleton?: boolean;
  onLikeProduct?: (id: string, status: boolean) => void;
  index?: number;
  cartId?: string;
}

const PharmaCard = ({
  product,
  className,
  cardClassName,
  id,
  skeleton = false,
  onLikeProduct,
  index,
  cartId
}: IProps) => {
  const navigate = useNavigate();
  const Tags = product?.productTagsName || [
    "Testosterone",
    "Free Testosterone",
    "Vitamins",
    "Minerals",
  ];

  return (
    <div
      id={index || index === 0 ? `pharma-card-${index + 1}` : id || ""}
      className={`w-full bg-white shadow-[0px_0px_7px_#00000029] border border-[#619B97] product-card-radius ${cardClassName} cursor-pointer`}
      onClick={() => {
        if (!skeleton && product?._id) {
          navigate(`/pharmacy-products/${product?._id || "dummy"}/view`);
        }
      }}
    >
      <div className="w-full aspect-[1/0.7] product-card-radius-image relative bg-[#F6F6F6] overflow-hidden flex items-center justify-center">
        {skeleton ? (
          <>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
            />
            <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
              <Skeleton variant="rectangular" width={40} height={60} />
              <Skeleton variant="circular" width={35} height={35} />
            </div>
            <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
              <Skeleton variant="rectangular" width={50} height={24} />
              <Skeleton variant="rectangular" width={40} height={40} />
            </div>
          </>
        ) : (
          <>
            <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
              <HowManytDealOFF
                regularPrice={product?.regularPrice}
                salePrice={product?.salePrice}
              />
              <FavoriteCoponent
                index={index}
                id={product?._id || "dummy"}
                liked={product?.isLiked}
                onLikeProduct={onLikeProduct}
                category="pharmacy"
              />
            </div>
            <img
              src={
                product && product?.mainImage
                  ?  product?.mainImage
                  : "/image-not-available.png"
              }
              alt=""
              className="max-w-[90%] max-h-[90%] object-contain"
            />
            <div className="absolute bottom-1 left-0 w-[100%] h-fit px-2 flex flex-col gap-1">
              
              <div className="flex items-center pb-1 justify-between">
                <div className="px-2 py-1 font-size-12px rounded-xl bg-[#F59E0B] text-white flex items-center justify-center gap-1">
                  <FontAwesomeIcon icon={faStar} />
                  <span className="font-Lexend-Regular">
                    {product?.averageRating
                      ? product?.averageRating?.toFixed(1)
                      : "0.0"}
                  </span>
                </div>
                <AddCartButton
                  type="pharmacy"
                  productId={product?._id || ""}
                  quantity={product?.quantity || 1}
                  itemType="product"
                  stockQuantity={product?.quantity || 0}
                  prescriptionRequired={product?.prescriptionRequired || false}
                  id={cartId || "add-cart-button-" + index || ""}
                  index={index}
                />
              </div>
              {/* {product?.quantity <= 0 && <OutOfStackTag />} */}
            </div>
          </>
        )}
      </div>
      <div className="w-full p-2 2xl:p-4 flex flex-col justify-between gap-2 xl:gap-3 min-h-[170px] xl:min-h-[190px] 2xl:min-h-[250px]">
        <div className="flex flex-col gap-2 xl:gap-3">
          {skeleton ? (
            <>
              <Skeleton variant="rectangular" width={100} height={24} />
              <Skeleton variant="text" width="90%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </>
          ) : (
            <>
              <div
                className="w-fit gap-1 text-white font-size-13px xl:mb-1 font-Lexend-Regular flex items-center rounded-md px-3 py-[5px]"
                style={{
                  backgroundColor:
                    product?.promotionalTagDetails?.color || "#08911F",
                }}
              >
                <span>
                  {product?.promotionalTagDetails?.name || "Pharmacist"}
                </span>{" "}
                <img src={Danger} alt="Danger" />
              </div>
              <p className="font-Poppins-Regular font-size-14px line-clamp-2 homepage-online-executive-deal-description-color cursor-pointer">
                {product?.productName ||
                  `Garden of Life Dr. Formulated Garden of Life Dr. Formulated Garden
                of Life Dr. Formulated Garden of Life Dr. Formulated Garden of Life
                Dr. Formulated Garden of Life Dr. Formulated`}
              </p>
              <PriceView
                regularPrice={product?.regularPrice}
                salePrice={product?.salePrice}
              />
            </>
          )}
        </div>
        {/* Tags */}
        <div className="w-full flex flex-col gap-1.5 xl:gap-2">
          {skeleton ? (
            <>
              <div className="flex gap-2">
                <Skeleton variant="rectangular" width={80} height={24} />
                <Skeleton variant="rectangular" width={80} height={24} />
                <Skeleton variant="text" width={20} height={24} />
              </div>
              <Skeleton variant="rectangular" width={100} height={24} />
            </>
          ) : (
            <>
              <div className="flex gap-1 xl:gap-2">
                {Tags.slice(0, 2).map((tag: string, index: number) => (
                  <div
                    key={index}
                    className="w-fit gap-1 font-size-12px font-Lexend-Regular flex items-center bg-[#F1F5F9] text-[#363636] rounded-md px-2 2xl:px-3 py-1 2xl:py-[6px]"
                  >
                    <span
                      className={`truncate block w-full max-w-[75px] ${
                        index === 0 ? "max-w-[120px]" : "max-w-[90px]"
                      }`}
                    >
                      {tag}
                    </span>
                  </div>
                ))}
                {/* {Tags.length > 2 && (
                  <div className="w-fit font-size-14px font-Lexend-Regular px-1 py-[5px]">
                    <span>...</span>
                  </div>
                )} */}
              </div>
              <div className="w-fit bg-[#F0FDF4] border border-[#BBF7D0] px-1.5 2xl:px-3 py-1 2xl:py-[6px] rounded-full flex items-center gap-1">
                <img
                  src={HistoryIcon}
                  alt="HistoryIcon"
                  className="w-[15px] 2xl:w-[19px]"
                />
                <span className="font-Lexend-Regular font-size-12px text-[#363636]">
                  In{" "}
                  {product?.deliveryType === "standard" ? "24 hours" : "30 min"}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PharmaCard;
